import { useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { rubricConfigByIdAtom } from '../../../services/state/RubricsStateJ';
import {
  selectedRubricConfigActionAtom,
  selectedRubricConfigIdAtom,
  useResetRubricConfigFormState,
} from './RubricConfigFormState';

export function useRubricConfigFormData() {
  const [selectedAction, setSelectedAction] = useAtom(selectedRubricConfigActionAtom);
  const [selectedConfigId, setSelectedConfigId] = useAtom(selectedRubricConfigIdAtom);
  const configsById = useAtomValue(rubricConfigByIdAtom);
  const selectedConfig = selectedConfigId ? configsById.get(selectedConfigId) : null;

  const resetFormState = useResetRubricConfigFormState();

  const defaultValues = useMemo(() => {
    if (selectedAction === 'edit' && selectedConfig) {
      return { ...selectedConfig };
    }
  }, [selectedAction, selectedConfig]);

  return {
    resetFormState,
    defaultValues,
    selectedAction,
    setSelectedAction,
    setSelectedConfigId,
    selectedConfig,
  };
}
